// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyAccount_container__n5gTo {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(to bottom right, #000000, #1a1a1a);
  padding: 20px;
}

.MyAccount_profileCard__XwgKL {
  background: #18181b;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 500px;
  border: 1px solid #27272a;
}

.MyAccount_title__zt2z0 {
  text-align: center;
  color: #DC2626;
  margin-bottom: 2rem;
  font-size: 1.8rem;
  font-weight: 600;
}
.MyAccount_error__Hw73c{
  color: #DC2626;

}

.MyAccount_userInfo__GP8oG {
  margin-bottom: 2rem;
}

.MyAccount_infoGroup__iHM4z {
  margin-bottom: 1rem;
}

.MyAccount_infoGroup__iHM4z label {
  display: block;
  color: #a1a1aa;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.MyAccount_infoGroup__iHM4z p {
  color: #fafafa;
  font-size: 1.1rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #27272a;
}

.MyAccount_changePasswordBtn__CIke6 {
  width: 100%;
  padding: 0.8rem;
  background-color: #DC2626;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s;
}

.MyAccount_changePasswordBtn__CIke6:hover {
  background-color: #000;
}

.MyAccount_modalOverlay__2698z {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.MyAccount_modal__kmFZH {
  background: #18181b;
  padding: 2rem;
  border-radius: 10px;
  width: 100%;
  max-width: 400px;
  border: 1px solid #27272a;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.MyAccount_modal__kmFZH h2 {
  text-align: center;
  color: #fafafa;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.MyAccount_inputGroup__qpUUN {
  margin-bottom: 1rem;
}

.MyAccount_passwordWrapper__dMqnS {
  position: relative;
  display: flex;
  align-items: center;
}

.MyAccount_input__cxjIc {
  width: 100%;
  padding: 0.8rem;
  padding-right: 2.5rem;
  background-color: #27272a;
  border: 1px solid #3f3f46;
  border-radius: 5px;
  font-size: 1rem;
  color: #fafafa;
  transition: border-color 0.2s;
}

.MyAccount_input__cxjIc:focus {
  outline: none;
  border-color: #DC2626;
}

.MyAccount_eyeButton__Kwwsy {
  position: absolute;
  right: 0.5rem;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  color: #a1a1aa;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.MyAccount_eyeButton__Kwwsy:hover {
  color: #fafafa;
}

.MyAccount_modalButtons__Nmft\\+ {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

.MyAccount_submitBtn__p3-Sq, .MyAccount_cancelBtn__XOOvM {
  flex: 1 1;
  padding: 0.8rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s;
}

.MyAccount_submitBtn__p3-Sq {
  background-color: #DC2626;
  color: white;
}

.MyAccount_submitBtn__p3-Sq:hover {
  background-color: #000;
}

.MyAccount_cancelBtn__XOOvM {
  background-color: #3f3f46;
  color: #fafafa;
}

.MyAccount_cancelBtn__XOOvM:hover {
  background-color: #52525b;
}

/* Responsive Styles */
@media (max-width: 640px) {
  .MyAccount_modal__kmFZH {
    padding: 1.5rem;
  }

  .MyAccount_modalButtons__Nmft\\+ {
    flex-direction: column;
  }

  .MyAccount_submitBtn__p3-Sq, .MyAccount_cancelBtn__XOOvM {
    width: 100%;
  }

  .MyAccount_input__cxjIc {
    font-size: 16px; /* Prevents zoom on mobile */
  }
}

@media (max-width: 380px) {
  .MyAccount_modal__kmFZH {
    padding: 1rem;
  }

  .MyAccount_modal__kmFZH h2 {
    font-size: 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/settings-pages/MyAccount.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,8DAA8D;EAC9D,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;;AAEhB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe,EAAE,4BAA4B;EAC/C;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(to bottom right, #000000, #1a1a1a);\n  padding: 20px;\n}\n\n.profileCard {\n  background: #18181b;\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  width: 100%;\n  max-width: 500px;\n  border: 1px solid #27272a;\n}\n\n.title {\n  text-align: center;\n  color: #DC2626;\n  margin-bottom: 2rem;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n.error{\n  color: #DC2626;\n\n}\n\n.userInfo {\n  margin-bottom: 2rem;\n}\n\n.infoGroup {\n  margin-bottom: 1rem;\n}\n\n.infoGroup label {\n  display: block;\n  color: #a1a1aa;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.infoGroup p {\n  color: #fafafa;\n  font-size: 1.1rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #27272a;\n}\n\n.changePasswordBtn {\n  width: 100%;\n  padding: 0.8rem;\n  background-color: #DC2626;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.2s;\n}\n\n.changePasswordBtn:hover {\n  background-color: #000;\n}\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.modal {\n  background: #18181b;\n  padding: 2rem;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 400px;\n  border: 1px solid #27272a;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.modal h2 {\n  text-align: center;\n  color: #fafafa;\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.inputGroup {\n  margin-bottom: 1rem;\n}\n\n.passwordWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input {\n  width: 100%;\n  padding: 0.8rem;\n  padding-right: 2.5rem;\n  background-color: #27272a;\n  border: 1px solid #3f3f46;\n  border-radius: 5px;\n  font-size: 1rem;\n  color: #fafafa;\n  transition: border-color 0.2s;\n}\n\n.input:focus {\n  outline: none;\n  border-color: #DC2626;\n}\n\n.eyeButton {\n  position: absolute;\n  right: 0.5rem;\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  cursor: pointer;\n  color: #a1a1aa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.eyeButton:hover {\n  color: #fafafa;\n}\n\n.modalButtons {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.submitBtn, .cancelBtn {\n  flex: 1;\n  padding: 0.8rem;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.2s;\n}\n\n.submitBtn {\n  background-color: #DC2626;\n  color: white;\n}\n\n.submitBtn:hover {\n  background-color: #000;\n}\n\n.cancelBtn {\n  background-color: #3f3f46;\n  color: #fafafa;\n}\n\n.cancelBtn:hover {\n  background-color: #52525b;\n}\n\n/* Responsive Styles */\n@media (max-width: 640px) {\n  .modal {\n    padding: 1.5rem;\n  }\n\n  .modalButtons {\n    flex-direction: column;\n  }\n\n  .submitBtn, .cancelBtn {\n    width: 100%;\n  }\n\n  .input {\n    font-size: 16px; /* Prevents zoom on mobile */\n  }\n}\n\n@media (max-width: 380px) {\n  .modal {\n    padding: 1rem;\n  }\n\n  .modal h2 {\n    font-size: 1.25rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MyAccount_container__n5gTo`,
	"profileCard": `MyAccount_profileCard__XwgKL`,
	"title": `MyAccount_title__zt2z0`,
	"error": `MyAccount_error__Hw73c`,
	"userInfo": `MyAccount_userInfo__GP8oG`,
	"infoGroup": `MyAccount_infoGroup__iHM4z`,
	"changePasswordBtn": `MyAccount_changePasswordBtn__CIke6`,
	"modalOverlay": `MyAccount_modalOverlay__2698z`,
	"modal": `MyAccount_modal__kmFZH`,
	"inputGroup": `MyAccount_inputGroup__qpUUN`,
	"passwordWrapper": `MyAccount_passwordWrapper__dMqnS`,
	"input": `MyAccount_input__cxjIc`,
	"eyeButton": `MyAccount_eyeButton__Kwwsy`,
	"modalButtons": `MyAccount_modalButtons__Nmft+`,
	"submitBtn": `MyAccount_submitBtn__p3-Sq`,
	"cancelBtn": `MyAccount_cancelBtn__XOOvM`
};
export default ___CSS_LOADER_EXPORT___;
